/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
// import ReactPlayer from 'react-player';
import ObroModal from '@/components/Modal';
import {
  AlignCenterIcon,
  AlignLeftIcon,
  AlignRightIcon,
  ImageIcon,
  ShowAnswerIcon,
  VideoIcon,
} from '@/icons/WhiteBoardIcons';
import { ReturnBackIcon } from '@/icons';
import { useTranslation } from 'react-i18next';
// import WebViewSolution from '../components/WebViewSolution';
import { DisplayTypes, PageItemCanvasModel, SbPageItemType } from '@/types';
import ReactPlayer from 'react-player';

type TestToolsProps = {
  currentPageItem: PageItemCanvasModel,
  displayType: DisplayTypes;
  dispatch: (action: any) => void;
  setDisplayType: (type: DisplayTypes) => void;
  pageItemPosition: 'left' | 'right' | 'center';
  updatePageItemPosition: (position: 'left' | 'right' | 'center') => void;
  collapseGapFillings: () => void;
  collapseSecondLayer: (show: boolean) => void;

};

const TestTools: React.FC<TestToolsProps> = (props) => {
  const {
    currentPageItem,
    displayType,
    dispatch,
    setDisplayType,
    updatePageItemPosition,
    collapseGapFillings,
    collapseSecondLayer
  } = props;

  const [showVideoSolution, setShowVideoSolution] = useState<boolean>(false);
  const [showImageSolution, setShowImageSolution] = useState<boolean>(false);
  const [showAnswer, setShowAnswer] = useState<boolean>(false);
  const { t } = useTranslation('translation', { keyPrefix: 'bottom_tools' });
  const [isMobile, setIsMobile] = useState<boolean>(false);
  
  // Ekran boyutunu kontrol edelim
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    setShowAnswer(false);

  }, [currentPageItem]);


  const showQuestionAnswer= (show: boolean) => {
    setShowAnswer(!show);
    collapseSecondLayer(show);
  }
  const renderShowAnswerButton = () => {
    if (
      currentPageItem.pageItemType === SbPageItemType.MultipleChoice &&
      currentPageItem.correctAnswer
    ) {
      return (
        <div style={{ position: 'relative' }}>
          <button onClick={() => showQuestionAnswer(showAnswer)}>
            <ShowAnswerIcon className={undefined} />
          </button>
          {showAnswer && (
            <div className="popover">
              <div>
                <span className="correct-answer-title">
                  {/* {store.currentPageItem.title}. {t('question')} */}
                </span>
              </div>
              <div>
                <span className="correct-answer">
                  {t('correct_answer')}: {currentPageItem.correctAnswer}
                </span>
              </div>
            </div>
          )}
        </div>
      );
    } else if (currentPageItem.pageItemType === 20) {
      return (
        <>
          <button
            onClick={() => {
              collapseGapFillings();
            }}
          >
            <ShowAnswerIcon className={undefined}  />
          </button>
        </>
      );
    }
  };

  return (
    <div className="content-tools" style={{zIndex: 2000}}>
      <button
        className="return-back-btn"
        onClick={() => dispatch(setDisplayType(DisplayTypes.Page))}
      >
        <ReturnBackIcon className={undefined} />
      </button>
      {currentPageItem.solutionImage && (
        <button onClick={() => setShowImageSolution(!showImageSolution)}>
          <ImageIcon className={undefined} />
        </button>
      )}
      {(currentPageItem.solutionVideo ||
        currentPageItem.solutionVideoId) && (
        <button onClick={() => setShowVideoSolution(!showVideoSolution)}>
          <VideoIcon className={undefined} />
        </button>
      )}
      <button
        className="tool-item"
        onClick={() => updatePageItemPosition('left')}
      >
        <AlignLeftIcon className={undefined} />
      </button>
      <button
        className="tool-item"
        onClick={() => updatePageItemPosition('center')}
      >
        <AlignCenterIcon className={undefined} />
      </button>
      <button
        className="tool-item"
        onClick={() => updatePageItemPosition('right')}
      >
        <AlignRightIcon className={undefined} />
      </button>
      {displayType === DisplayTypes.PageItem && renderShowAnswerButton()}
      {showVideoSolution && (
        <ObroModal
          header={`Çözüm- ${currentPageItem.order}. Soru`}
          showModal={showVideoSolution}
          setIsOpen={setShowVideoSolution}
          width={isMobile ? window.innerWidth * 0.9 : 900}
          height={isMobile ? "auto" : "auto"}
        >
          <div className="responsive-player-container">
            <ReactPlayer
              width="100%"
              height={isMobile ? "auto" : "480px"}
              controls
              url={currentPageItem.solutionVideo}
              style={{ maxWidth: '100%' }}
            />
          </div>
        </ObroModal>
      )}
      {showImageSolution && (
        <ObroModal
          header={`Çözüm- ${currentPageItem.order}. Soru`}
          showModal={showImageSolution}
          setIsOpen={setShowImageSolution}
          width={isMobile ? window.innerWidth * 0.9 : 800}
        >
          <div className="responsive-image-container">
            <img
              alt="Solution"
              className="img-fluid card-img-top mt-1 responsive-solution-image"
              style={{ 
                maxHeight: isMobile ? '60vh' : '400px', 
                width: 'auto', 
                maxWidth: '100%',
                objectFit: 'contain'
              }}
              src={currentPageItem.solutionImage}
            />
          </div>
        </ObroModal>
      )}
    </div>
  );
};

export default TestTools;
